import http from 'conversations-http/clients/http';
export const fetchPromptData = ({
  promptType
}) => http.get(`cv/inbox/settings/v1/user-prompts`, {
  query: {
    promptType
  }
});